/**
 * WelcomeModalGate — shows `WelcomeModal` once, right after the onboarding
 * wizard's redirect to the home page.
 *
 * The wizard marks the flag before it reloads to `/` (see `welcomeFlag.js`);
 * this gate consumes it on mount, so the modal appears exactly once and a
 * later reload, close, or revisit never brings it back.
 */
import React, { useState } from 'react';

import { consumeWelcomePending } from '../utils/welcomeFlag';
import WelcomeModal from './WelcomeModal';

export default function WelcomeModalGate({ consume = consumeWelcomePending }) {
    // Lazy initializer: the flag is read (and cleared) once per mount, never
    // again on re-render.
    const [open, setOpen] = useState(() => consume());
    return <WelcomeModal open={open} onClose={() => setOpen(false)} />;
}
